import s from './Breeds.module.css';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';
import { BackButton } from 'components/BackButton/BackButton';
import { BreedsLabel } from 'components/MenuLabels/BreedsLabel/BreedsLabel';
import { CatsCollection } from 'components/CatsCollection/CatsCollection';
import { fetchAllBreeds } from 'services/API/API';
import { SelectBreeds } from 'components/SelectBreeds/SelectBreeds';
import CustomOption from 'components/SelectBreeds/customOption';
import { useState } from 'react';
import { useEffect } from 'react';
import { SelectNumberImages } from 'components/SelectNumberImages/SelectNumberImages';
import { AscDescBtn } from 'components/AscDescBtn/AscDescBtn';
import { LabelStyleBreeds } from 'components/CatsCollection/labelStyleBreeds';

const Breeds = () => {
  const [images, setImages] = useState([]);
  const [breed, setBreed] = useState('');
  const [imagesNumber, setImagesNumber] = useState(10);

  useEffect(() => {
    console.log('now doing');
    fetchAllBreeds(imagesNumber, breed).then(images => setImages(images));
  }, [imagesNumber, breed]);

  useEffect(() => {
    localStorage.setItem('images', JSON.stringify(images));
  }, [images]);

  const selectHandle = breed => {
    setBreed(breed);
  };

  const selectHandleNumber = value => {
    setImagesNumber(value);
  };

  const ascDescHandler = data => {
    if (data) {
      fetchAllBreeds(imagesNumber, breed, 'DESC').then(images =>
        setImages(images)
      );
    } else {
      fetchAllBreeds(imagesNumber, breed, 'ASC').then(images =>
        setImages(images)
      );
    }
  };

  return (
    <div className={s.main}>
      <NavigationHeader />

      <div className={s.container}>
        <div className={s.navigation}>
          <BackButton path={'/'} />
          <BreedsLabel />
          <SelectBreeds
            onSelect={selectHandle}
            components={{ Option: CustomOption }}
            startListValue={{ name: 'All', label: 'All', id: 1 }}
          />
          <SelectNumberImages onSelect={selectHandleNumber} />
          <AscDescBtn onAction={ascDescHandler} />
        </div>

        <CatsCollection
          images={images}
          destination="breed"
          numberImages={imagesNumber}
          actualSyleLabelHover={LabelStyleBreeds}
        />
      </div>
    </div>
  );
};
export { Breeds };
